import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { create, windowScheduler } from "@yornaath/batshit";
import uniqBy from "lodash/uniqBy";
import { SystemCatalog } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const fetchEntityTitles = (entities) => SystemCatalog.getTitles({ entities });
const entityTitles = create({
  fetcher: (entities) => defaultOnError(
    fetchEntityTitles(uniqBy(entities, ({ id, type }) => `${type}:${id}`)),
    "Loading entity titles failed with status",
    "Could not load entity titles"
  ),
  resolver: (response, { id }) => {
    var _a, _b, _c;
    return {
      id,
      title: (_b = (_a = response.entities) == null ? void 0 : _a.find((entity) => entity.id === id)) == null ? void 0 : _b.title,
      isPermitted: !((_c = response.not_permitted_to_view) == null ? void 0 : _c.includes(id))
    };
  },
  scheduler: windowScheduler(10)
});
const useEntityTitles = (entities) => {
  const stableEntities = [...entities].sort((a, b) => a.id.localeCompare(b.id));
  const enabled = stableEntities.length > 0;
  const { data, isInitialLoading, isFetching, isError } = useQuery({
    queryKey: ["entity_titles", stableEntities],
    queryFn: () => Promise.all(stableEntities.map((entity) => entityTitles.fetch(entity))),
    enabled,
    placeholderData: keepPreviousData
  });
  const titlesById = Object.fromEntries(
    (data != null ? data : []).filter(({ title }) => title !== void 0).map(({ id, title }) => [id, title])
  );
  const notPermittedIds = new Set((data != null ? data : []).filter(({ isPermitted }) => !isPermitted).map(({ id }) => id));
  return {
    titlesById,
    notPermittedIds,
    isInitialLoading,
    isFetching,
    isError
  };
};
export default useEntityTitles;
